const deepMerge = (target, source) => {
  if (typeof target !== 'object' || target === null) {
    return source;
  }

  if (Array.isArray(target)) {
    return [...target, ...source];
  }

  return Object.keys(source).reduce(
    (acc, key) => {
      if (typeof source[key] === 'object' && source[key] !== null) {
        acc[key] = deepMerge(acc[key] || {}, source[key]);
      } else {
        acc[key] = source[key];
      }
      return acc;
    },
    { ...target }
  );
};
export default function plpOnLanding(state = {}, action) {
  if (action.type === 'SET_PLP_ON_LANDING_DATA') {
    return action.noProductsForPriceFilter
      ? {
          ...state,
          noProductsForPriceFilter: action.noProductsForPriceFilter
        }
      : { ...state, ...action.data, noProductsForPriceFilter: false };
  }
  if (action.type === 'UPDATE_PLP_ON_LANDING_DATA') {
    return deepMerge(state, action.data);
  }
  if (action.type === 'SET_PLP_ON_LANDING_SOURCE') {
    return { ...state, plpOnlandingSource: action.data };
  }
  if (action.type === 'SET_PLP_ON_LANDING_BANNER_DATA') {
    return { ...state, bannerData: action.data };
  }
  return state;
}
